export * from './wixmg-player';



// WEBPACK FOOTER //
// ./index.ts